export default __webpack_public_path__ + "static/filewithgolddust-012682629a41abc51231901b995956eb.png";